<template>
  <b-card>
    <b-card-title>
      Previous Purple Phone Calls
    </b-card-title>

    <section v-if="loading">
      <b-spinner variant="primary" label="Loading previous calls"></b-spinner>
    </section>

    <section v-else>
      <section class="previous-visits-table" v-if="calls && calls.length > 0">
        <p><b>All Previous Video Calls</b></p>
        <b-table
          class="data-table"
          hover
          :items="calls"
          :fields="headers"
          :current-page="currentPage"
          :per-page="perPage"
          :busy="loading"
          :responsive="true"
        >
          <template #cell(call_type)="data">
            <span v-if="data.item.call_type === 'AppToMobile'">App to Mobile</span>
            <span v-else>App to App</span>
          </template>

          <template #cell(started)="data">
                <span v-if="data.item.started">
                  {{data.item.started | formatDateTime}}
                </span>
            <span v-else>
                  -
                </span>
          </template>

          <template #cell(ended)="data">
                <span v-if="data.item.ended">
                  {{data.item.ended | formatDateTime}}
                </span>
            <span v-else>
                  -
                </span>
          </template>

          <template #cell(actions)="data">
            <b-btn variant="link" @click="$router.push({ name: 'purple-phone-call-details', params: { id: data.item._id } })">View</b-btn>
          </template>

        </b-table>
      </section>
      <b-row v-if="calls && calls.length > 0">
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalCalls" :per-page="perPage" v-model="currentPage" class="my-0"/>
        </b-col>
      </b-row>
      <div v-if="!calls || calls.length === 0">
        <p>Visitor has no previous phone calls</p>
      </div>
    </section>
  </b-card>
</template>

<script>
import PurplePhoneCallsService from '@/services/PurplePhoneCallsService';

export default {
  props: {
    visitor_user_id: {
      type: String,
      required: false,
    },
    purple_phone_number_id: {
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: true,
      calls: [],
      totalCalls: 0,
      currentPage: 1,
      perPage: 10,
      headers: [
        {
          label: 'Prison Number',
          key: 'prisoner_number',
        },
        {
          label: 'Recipient',
          key: 'recipient.name',
        },
        {
          label: 'Relationship',
          key: 'recipient.relationship',
        },
        {
          label: 'Type',
          key: 'call_type',
        },
        {
          label: 'Started',
          key: 'started',
        },
        {
          label: 'Ended',
          key: 'ended',
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ]
    };
  },
  mounted() {
    this.getCalls();
  },
  watch: {
    currentPage() {
      this.getCalls()
    },
  },
  methods: {
    async getCalls() {
      try {
        const filter = {}
        if(this.visitor_user_id) {
          filter.userId = this.visitor_user_id
        }
        if(this.purple_phone_number_id) {
          filter.purplePhoneNumberId = this.purple_phone_number_id
        }
        const {data} = await PurplePhoneCallsService.list({
          limit: this.perPage,
          skip: (this.currentPage - 1) * this.perPage,
          ...filter,
        })
        this.calls = data.data;
        this.totalCalls = data.count
      } catch(err) {
        console.error('Error getting purple phone calls: ', err)
        this.$toast.error('Could not get purple phone calls, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
